<h2 mat-dialog-title>Sucesso!</h2>
<mat-dialog-content>
  Enviamos as intruções de mudanças de senha para {{email}}.
  <br> Por favor, verifique sua caixa de entrada e a de spam.
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button type="button" color="accent" [mat-dialog-close]="true">Ok</button>
</mat-dialog-actions>
